import { map } from '@/api/api-endpoints'

export default {
  data() {
    return {
      optionalYears: [],
      showYearModal: false,
      baseYear: false,
      year: null,
      errorFlag: false,
      errorText: 'Данный год не может быть выбран',
      editParam: false,
      tariffFields: [
        {
          label: 'Единый тариф на куб.м',
          unit: 'руб/куб.м',
          name: 'single_tariff_cubic',
          value: null,
        },
        {
          label: ' Единый тариф на тонну',
          name: 'single_tariff',
          unit: 'руб/т',
          value: null,
        },
        {
          label:
            'НВВ РО - необходимая валовая выручка регионального оператора в году',
          name: 'nvv_ro',
          unit: 'руб',
          value: null,
        },
        {
          label:
            'НВВ РО О - расходы регионального оператора по обработке, обезвреживанию, энергетической утилизации, захоронению твердых коммунальных отходов на объектах, используемых для обращения с твердыми коммунальными отходами, руб',
          name: 'nvv_ro_o',
          value: null,
          disabled: true,
        },
        {
          label: ' НВВ РО СОБ - собственные расходы регионального оператора',
          name: 'nvv_ro_sob',
          unit: 'руб',
          value: null,
          disabled: true,
        },
        {
          label: 'НВВ ТР - расходы на транспортирование',
          name: 'nvv_tr',
          unit: 'руб',
          value: null,
          disabled: true,
        },
        {
          label:
            'дельта t +1 - корректировка расходов на транспортирование отходов в году (i + 1)',
          name: 'delta_t1',
          value: null,
          disabled: true,
        },
        {
          label: 'НВВ ПР - прочие расходы регионального оператора',
          name: 'nvv_pr',
          unit: 'руб',
          value: null,
          disabled: true,
        },
        {
          label: 'расчетная предпринимательская прибыль',
          name: 'estimated_profit',
          autoCheck: 'estimated_profit_check',
          autoCheckText:
            '< 5% от транспортных затрат и расходов на заключение договоров',
          unit: 'руб',
          value: null,
          disabled: true,
        },
        {
          label: 'Дополнительные значения',
          name: 'additional_meanings',
          unit: 'руб',
          value: null,
          disabled: true,
        },
      ],
      coefFilds: [
        {
          label: 'Плотность отходов',
          name: 'waste_density',
          required: true,
          fixed: 3,
          value: null,
        },
        {
          label:
            'n - коэффициент снижения расходов на транспортирование отходов после сортировки или перегрузки',
          name: 'cost_reduction_ratio',
          value: 0.4,
        },
        {
          label: 'ИПЦ - индекс потребительских цен',
          name: 'ipc',
          unit: '%',
          value: null,
        },
        {
          label: 'W PO -Масса транспортируемых оператором отходов',
          name: 'wpo',
          unit: 'т',
          value: null,
        },
        {
          label: 'Q РО - Объем транспортируемых оператором отходов',
          name: 'qpo',
          unit: 'куб.м',
          value: null,
        },
        {
          label: 'Доля вывоза ТКО силами РО',
          name: 'ro',
          unit: '%',
          value: null,
        },
      ],
      calcFilds: [
        {
          label:
            'T Q - тариф оператора по обращению с твердыми коммунальными отходами',
          name: 'tq',
          unit: 'руб',
          value: null,
        },
        {
          label: 'НВВ на объекты',
          name: 'nvv_objects',
          value: null,
          unit: 'руб',
        },
        {
          label:
            'дельта НВВ РО - корректировка необходимой валовой выручки регионального оператора',
          name: 'nvv_ro_delta',
          unit: 'руб',
          value: null,
        },
        {
          label: 'НВВ ТР - расходы на транспортирование',
          name: 'nvv_tr',
          unit: 'руб',
          value: null,
        },
        {
          label:
            'l1 - среднее расстояние транспортирования отходов первого плеча (от источника образования или накопления отходов до объекта по обращению с отходами без осуществления сортировки или перегрузки) соответственно в годах (i+1), i ',
          name: 'l1',
          unit: 'км',
          value: null,
        },
        {
          label:
            'l2 - среднее расстояние транспортирования отходов второго плеча (от перегрузки или сортировки до объекта, на котором осуществляется обезвреживание, энергетическая утилизация или захоронение отходов) соответственно в годах (i+1), i',
          name: 'l2',
          unit: 'км',
          value: null,
        },
        {
          label:
            'НВВ ПР х - расходы на оказание комплексной услуги по обращению с твердыми отходами',
          name: 'nvv_pr_x_complex',
          unit: 'руб',
          value: null,
        },
        {
          label:
            'НВВ ПР х - расходы на заключение и обслуживание договоров с собственниками твердых коммунальных отходов и операторами по обращению с твердыми коммунальными отходами',
          name: 'nvv_pr_x_contract',
          unit: 'руб',
          value: null,
        },
        {
          label: 'НВВ СБ - сбытовые расходы регионального оператора',
          name: 'nvv_sb',
          autoCheck: 'nvv_sb_check',
          autoCheckText:
            '(не более 5% в 2022-2024 гг., не более 3% в 2025-2026 гг., не более 2% с 2027 г. от НВВ РО)',
          unit: 'руб',
          value: null,
        },
        {
          label:
            'Расходы на приобретение контейнеров и бункеров и их содержание, включая расходы на лизинговые платежи в отношении контейнеров и бункеров ',
          name: 'cost_containers',
          autoCheck: 'cost_containers_check',
          autoCheckText: '< 1 от НВВ РО',
          unit: 'руб',
          value: null,
        },
        {
          label: 'Расходы на уборку мест погрузки ТКО',
          name: 'cost_cleaning',
          unit: 'руб',
          value: null,
        },
        {
          label: 'Расходы на обслуживание безотзывной банковской гарантии',
          name: 'cost_bank_service',
          autoCheck: 'cost_bank_service_check',
          autoCheckText: '< 2 от НВВ РО',
          unit: 'руб',
          value: null,
        },
      ],
    }
  },
  computed: {
    coeffUrlPost() {
      return map.tariff_coeff()
    },
    calcUrlPost() {
      return map.tariff_values()
    },
  },
  created() {
    this.takeData()
  },
}
